export const Colors = {
  primary: '#3B71C9',
  tableTitles: '#6889c1', //'#7BA3E5',
  tableTitlesBar: '#7ba3e5',
  btn: '#797979',
  background: '#fff',
  borderMain: '#D9E7FE',
  text: '#2b2b2b',
  textInactive: '#808080',
  greenBar: '#2ec98f',
  //greenBar: '#2EC98F',
  selectedBadge: '#E6EFFF',
};
